export type PresetType = {
  value: string
  label: string
  isProFeature?: boolean
}

export const FEMALE_PRESETS: PresetType[] = [
  { value: "Undress", label: "Undress", isProFeature: false },
  { value: "Bra", label: "Bra", isProFeature: false },
  { value: "Bikini", label: "Bikini", isProFeature: false },
  { value: "Lingerie", label: "Lingerie", isProFeature: false },
  { value: "Tattoo", label: "Tattoo", isProFeature: false },
  { value: "Small Breasts", label: "Small Breasts", isProFeature: true },
  { value: "Flat Breasts", label: "Flat Breasts", isProFeature: true },
  { value: "Big Breasts", label: "Big Breasts", isProFeature: true },
  { value: "Fake Breasts", label: "Fake Breasts", isProFeature: true },
  { value: "Thick", label: "Thick", isProFeature: true },
  { value: "Skinny", label: "Skinny", isProFeature: true },
  { value: "Tight Dress", label: "Tight Dress", isProFeature: true },
  { value: "Saggy Breasts", label: "Saggy Breasts", isProFeature: true },
]

export const MALE_SETTINGS: PresetType[] = [
  { value: "MaleUndress", label: "Undress", isProFeature: false },
  { value: "MaleTattoo", label: "Tattoo", isProFeature: false },
  { value: "Underwear", label: "Underwear", isProFeature: false },
  { value: "Beard", label: "Beard", isProFeature: false },
  { value: "MaleSkinny", label: "Skinny_m", isProFeature: true },
  { value: "Fat", label: "Fat", isProFeature: true },
  { value: "Muscular", label: "Muscular", isProFeature: true },
  { value: "Fit", label: "Fit", isProFeature: true },
  { value: "Erect Penis", label: "Erect Penis", isProFeature: true },
]
